<template>
  <el-container
    style="
      max-width: 1000px;
      min-width: 700px;
      margin: auto;
      height: calc(100vh - 120px);
    "
  >
    <el-aside style="width: 100px">
      <div style="height: 100%">
        <el-menu
          default-active="1"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          :router="true"
          style="height: 100%"
        >
          <el-menu-item index="1" route="/function">
            <span>程序简介</span>
          </el-menu-item>
          <el-menu-item index="2" route="/install">
            <span>下载安装</span>
          </el-menu-item>
          <el-menu-item index="3" route="/use">
            <span>快速上手</span>
          </el-menu-item>
          <el-menu-item index="4" route="/error">
            <span>FAQ问题</span>
          </el-menu-item>
        </el-menu>
      </div>
    </el-aside>
    <el-main>
      <el-scrollbar height="100vh"><router-view></router-view></el-scrollbar>
    </el-main>
  </el-container>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    handleOpen(key, route) {
      this.$router.push(route);
    },
    handleClose(key, route) {},
  },
};
</script>
